module.exports = __webpack_public_path__ + "img/formules.b9b45679.svg";